/** Independent tickets prevent insight refreshes from cancelling dashboard requests. */
export function createRequestGate() {
  let generation = 0;
  return { begin: () => ++generation, isCurrent: ticket => ticket === generation, invalidate: () => { generation += 1; } };
}
/** A saved pairing belongs to a site, not to the range/model at mutation start. */
export function pairingRefreshContext(savedSite, current) {
  return savedSite && current?.selected === savedSite ? { ...current } : null;
}
export function sameDashboardContext(left, right) {
  return left?.selected === right?.selected && left?.range === right?.range && left?.model === right?.model;
}

/** Property errors must not discard a valid session during an outage. */
export async function loadDashboardSites(fetchSites) {
  try {
    const properties = await fetchSites();
    return {status: 'ready', properties, selected: properties[0]?.id || null,
      view: properties.length === 1 ? 'site' : 'overview'};
  } catch (error) {
    return {status: error.response?.status === 401 ? 'expired' : 'error'};
  }
}
